import { HttpErrorResponse } from '@angular/common/http';
import { Observable } from 'rxjs';

import {
  DiagnosticStatus,
  ErrorBaseReport,
  ErrorDetails,
  ErrorReport,
} from '../../models';

export abstract class Troubleshooting<TReportDetails = unknown> {
  createErrorBaseReport(error: HttpErrorResponse): ErrorBaseReport {
    let message = error.message;
    let statusText = error.statusText;

    if (error.status === 0) {
      message = navigator.onLine
        ? 'Network/server error: request not completed (possible CORS/Firewall/DNS/Timeout)'
        : 'No internet connection';
      statusText = 'Connection failed';
    }

    return {
      status: error.status,
      statusText,
      message,
      url: error.url ?? '',
      error: error.error,
    };
  }

  abstract getErrorDetails(): ErrorDetails;
  abstract getErrorReports(): { [key: string]: ErrorReport<TReportDetails>[] | string; };
  abstract getStatus(): DiagnosticStatus;
  abstract run(): Observable<void>;
}
